var requireObjectCoercible = require('../internals/require-object-coercible');

// `ToObject` abstract operation
// https://tc39.github.io/ecma262/#sec-toobject
module.exports = function (argument) {
  return Object(requireObjectCoercible(argument));
};



//////////////////
// WEBPACK FOOTER
// ../node_modules/core-js/internals/to-object.js
// module id = 13
// module chunks = 20 21 22 23 24 25 26 27 28 29 30 31 32 33 34 35